import { render } from "./App.vue?vue&type=template&id=8e1c0fdc&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=8e1c0fdc&scoped=true&lang=css"

import exportComponent from "/Users/fernandogatti/projetos/devix/webstory/webstory-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e1c0fdc"]])

export default __exports__